const Playcount = (props) => {

    const {
        playcount
    } = props;

  return playcount.toLocaleString();
}

export default Playcount